import { 
	Button, 
	createStyles, 
	Dialog, 
	DialogActions, 
	DialogContent, 
	DialogContentText, 
	DialogTitle, 
	Theme, 
	WithStyles, 
	withStyles } from '@material-ui/core/'
import React from 'react'
import { isIE } from '../services/utils'
import { authProvider } from './HOCs/AuthProvider/AuthProvider'
import AppHeader from './Templates/Header/Header'
import MainLanding from './Templates/MainLanding/MainLanding'
import RealLogos from './Templates/REALLogos/RealLogos'

const MainWithAuth = authProvider(MainLanding)
const INITIAL_STATE = {
	confirmedWarningDialog: false
}


interface BootstrapProps extends WithStyles<typeof styles> {}

export class Bootstrap extends React.Component<BootstrapProps, {}> {

	public readonly state = INITIAL_STATE

	public render() {
		const { classes } = this.props
		const { confirmedWarningDialog } = this.state

		return (
			<div className={classes.root}>
				<div className={classes.appContainer}>
					<div className={classes.appHeader}>
						<AppHeader />
					</div>
					<div className={`${classes.layoutBreakpoints} ${classes.mainHeader}`} id='mainHeader'>
            <Button className={`${classes.dateChangeBtn}`} id='dateChangeBtn' variant="contained" onClick={() => {    window.location.href = 'https://forms.office.com/g/8JHKGKF30K';}}>
              Enrollment Period Extension Request Form
						</Button>
						<RealLogos />
					</div>
					<div className={`${classes.layoutBreakpoints} ${classes.siteContent}`}>
						<MainWithAuth />
					</div>
					<div>
			      <Dialog
			        open={isIE && !confirmedWarningDialog}
			        keepMounted={true}
			        aria-labelledby="alert-dialog-slide-title"
			        aria-describedby="alert-dialog-slide-description"
			      >
			        <DialogTitle id="alert-dialog-slide-title">Older Browser Detected</DialogTitle>
			        <DialogContent>
			          <DialogContentText id="alert-dialog-slide-description">
					  We have detected that you are using an older browser. As a result,
					  you may encounter issues on this site, or may have difficulty with
					  some of the site features. Please consider using a newer browser
					  such as Chrome, Firefox, or Microsoft Edge.
			          </DialogContentText>
			        </DialogContent>
			        <DialogActions>
			          <Button onClick={() => {this.setState({confirmedWarningDialog: true})}} color="primary">
			            OK
			          </Button>
			        </DialogActions>
			      </Dialog>
			    </div>
				</div>
			</div>
		)
	}
}

const styles = (theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			minHeight: '100vh',
			flexDirection: 'column',
		},
		appContainer: {
			flex: '1',
		},
		appHeader: {
			flexBasis: '50px',
		},
		siteContent: {
			display: 'flex',
			minHeight: '50vh',
		},
		mainHeader: {
			paddingTop: `${theme.spacing.unit * 2}px`,
			display: 'flex',
			flex: 1,
			justifyContent: 'flex-end',
		},
		layoutBreakpoints: {
			margin: '0 auto',
			[theme.breakpoints.up('lg')]: {
				width: '90%',
			},
			[theme.breakpoints.down('md')]: {
				width: '95%',
			},
		},
    dateChangeBtn:{
      display:'none',
      textTransform: 'none'
    }
	})

export default withStyles(styles)(Bootstrap)
